import axios from "axios";
import Config from "src/config";
import { authHeaders } from 'src/actions/authHeaders';

const v2_actionCriarAgente = (clienteId, data) => {
    return axios({
        headers: authHeaders(),
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/${clienteId}/ai/agentes/criar`,
        data
        });
};

export default v2_actionCriarAgente;
